import gql from 'graphql-tag';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: any }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the
   * `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO
   * 8601 standard for representation of dates and times using the Gregorian calendar.
   */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** Input type for dynamic zone content of Section */
  SectionContentDynamicZoneInput: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
  /**
   * A date string, such as 2007-12-03, compliant with the `full-date` format
   * outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for
   * representation of dates and times using the Gregorian calendar.
   */
  Date: any;
  /** The `Long` scalar type represents 52-bit integers */
  Long: any;
  /** A time string with format: HH:mm:ss.SSS */
  Time: any;
};



export type Abbreviation = {
  __typename?: 'Abbreviation';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  acronym: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};

export type AbbreviationAggregator = {
  __typename?: 'AbbreviationAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AbbreviationConnection = {
  __typename?: 'AbbreviationConnection';
  values?: Maybe<Array<Maybe<Abbreviation>>>;
  groupBy?: Maybe<AbbreviationGroupBy>;
  aggregate?: Maybe<AbbreviationAggregator>;
};

export type AbbreviationConnection_Id = {
  __typename?: 'AbbreviationConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AbbreviationConnection>;
};

export type AbbreviationConnectionAcronym = {
  __typename?: 'AbbreviationConnectionAcronym';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<AbbreviationConnection>;
};

export type AbbreviationConnectionCreatedAt = {
  __typename?: 'AbbreviationConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<AbbreviationConnection>;
};

export type AbbreviationConnectionDescription = {
  __typename?: 'AbbreviationConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<AbbreviationConnection>;
};

export type AbbreviationConnectionId = {
  __typename?: 'AbbreviationConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<AbbreviationConnection>;
};

export type AbbreviationConnectionUpdatedAt = {
  __typename?: 'AbbreviationConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<AbbreviationConnection>;
};

export type AbbreviationGroupBy = {
  __typename?: 'AbbreviationGroupBy';
  id?: Maybe<Array<Maybe<AbbreviationConnectionId>>>;
  _id?: Maybe<Array<Maybe<AbbreviationConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<AbbreviationConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<AbbreviationConnectionUpdatedAt>>>;
  acronym?: Maybe<Array<Maybe<AbbreviationConnectionAcronym>>>;
  description?: Maybe<Array<Maybe<AbbreviationConnectionDescription>>>;
};

export type AbbreviationInput = {
  acronym: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};

export type Chart = {
  __typename?: 'Chart';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  title?: Maybe<Scalars['String']>;
  table?: Maybe<Table>;
  number: Scalars['String'];
};

export type ChartAggregator = {
  __typename?: 'ChartAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ChartConnection = {
  __typename?: 'ChartConnection';
  values?: Maybe<Array<Maybe<Chart>>>;
  groupBy?: Maybe<ChartGroupBy>;
  aggregate?: Maybe<ChartAggregator>;
};

export type ChartConnection_Id = {
  __typename?: 'ChartConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ChartConnection>;
};

export type ChartConnectionCreatedAt = {
  __typename?: 'ChartConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ChartConnection>;
};

export type ChartConnectionId = {
  __typename?: 'ChartConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ChartConnection>;
};

export type ChartConnectionNumber = {
  __typename?: 'ChartConnectionNumber';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ChartConnection>;
};

export type ChartConnectionTable = {
  __typename?: 'ChartConnectionTable';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ChartConnection>;
};

export type ChartConnectionTitle = {
  __typename?: 'ChartConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ChartConnection>;
};

export type ChartConnectionUpdatedAt = {
  __typename?: 'ChartConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ChartConnection>;
};

export type ChartGroupBy = {
  __typename?: 'ChartGroupBy';
  id?: Maybe<Array<Maybe<ChartConnectionId>>>;
  _id?: Maybe<Array<Maybe<ChartConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<ChartConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<ChartConnectionUpdatedAt>>>;
  title?: Maybe<Array<Maybe<ChartConnectionTitle>>>;
  table?: Maybe<Array<Maybe<ChartConnectionTable>>>;
  number?: Maybe<Array<Maybe<ChartConnectionNumber>>>;
};

export type ChartInput = {
  title?: Maybe<Scalars['String']>;
  table?: Maybe<Scalars['ID']>;
  number: Scalars['String'];
};

export type ComponentReportContentChart = {
  __typename?: 'ComponentReportContentChart';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  chart?: Maybe<Chart>;
};

export type ComponentReportContentChartInput = {
  chart?: Maybe<Scalars['ID']>;
};

export type ComponentReportContentImage = {
  __typename?: 'ComponentReportContentImage';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  image?: Maybe<Image>;
};

export type ComponentReportContentImageInput = {
  image?: Maybe<Scalars['ID']>;
};

export type ComponentReportContentParagraph = {
  __typename?: 'ComponentReportContentParagraph';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  paragraph?: Maybe<Paragraph>;
};

export type ComponentReportContentParagraphInput = {
  paragraph?: Maybe<Scalars['ID']>;
};

export type ComponentReportContentReference = {
  __typename?: 'ComponentReportContentReference';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  reference?: Maybe<Reference>;
};

export type ComponentReportContentReferenceInput = {
  reference?: Maybe<Scalars['ID']>;
};

export type ComponentReportContentSection = {
  __typename?: 'ComponentReportContentSection';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  section?: Maybe<Section>;
};

export type ComponentReportContentSectionInput = {
  section?: Maybe<Scalars['ID']>;
};

export type ComponentReportContentStyledTable = {
  __typename?: 'ComponentReportContentStyledTable';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  styled_table?: Maybe<StyledTable>;
};

export type ComponentReportContentStyledTableInput = {
  styled_table?: Maybe<Scalars['ID']>;
};

export type ComponentReportContentTable = {
  __typename?: 'ComponentReportContentTable';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  table?: Maybe<Table>;
};

export type ComponentReportContentTableInput = {
  table?: Maybe<Scalars['ID']>;
};

export type Country = {
  __typename?: 'Country';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  partOf?: Maybe<Scalars['String']>;
};

export type CountryAggregator = {
  __typename?: 'CountryAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CountryConnection = {
  __typename?: 'CountryConnection';
  values?: Maybe<Array<Maybe<Country>>>;
  groupBy?: Maybe<CountryGroupBy>;
  aggregate?: Maybe<CountryAggregator>;
};

export type CountryConnection_Id = {
  __typename?: 'CountryConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CountryConnection>;
};

export type CountryConnectionCreatedAt = {
  __typename?: 'CountryConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CountryConnection>;
};

export type CountryConnectionId = {
  __typename?: 'CountryConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CountryConnection>;
};

export type CountryConnectionName = {
  __typename?: 'CountryConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CountryConnection>;
};

export type CountryConnectionPartOf = {
  __typename?: 'CountryConnectionPartOf';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CountryConnection>;
};

export type CountryConnectionUpdatedAt = {
  __typename?: 'CountryConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CountryConnection>;
};

export type CountryGroupBy = {
  __typename?: 'CountryGroupBy';
  id?: Maybe<Array<Maybe<CountryConnectionId>>>;
  _id?: Maybe<Array<Maybe<CountryConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<CountryConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<CountryConnectionUpdatedAt>>>;
  name?: Maybe<Array<Maybe<CountryConnectionName>>>;
  partOf?: Maybe<Array<Maybe<CountryConnectionPartOf>>>;
};

export type CountryInput = {
  name: Scalars['String'];
  partOf?: Maybe<Scalars['String']>;
};

export type CreateAbbreviationInput = {
  data?: Maybe<AbbreviationInput>;
};

export type CreateAbbreviationPayload = {
  __typename?: 'createAbbreviationPayload';
  abbreviation?: Maybe<Abbreviation>;
};

export type CreateChartInput = {
  data?: Maybe<ChartInput>;
};

export type CreateChartPayload = {
  __typename?: 'createChartPayload';
  chart?: Maybe<Chart>;
};

export type CreateCountryInput = {
  data?: Maybe<CountryInput>;
};

export type CreateCountryPayload = {
  __typename?: 'createCountryPayload';
  country?: Maybe<Country>;
};

export type CreateImageInput = {
  data?: Maybe<ImageInput>;
};

export type CreateImagePayload = {
  __typename?: 'createImagePayload';
  image?: Maybe<Image>;
};

export type CreateJobInput = {
  data?: Maybe<JobInput>;
};

export type CreateJobPayload = {
  __typename?: 'createJobPayload';
  job?: Maybe<Job>;
};

export type CreateObjectiveInput = {
  data?: Maybe<ObjectiveInput>;
};

export type CreateObjectivePayload = {
  __typename?: 'createObjectivePayload';
  objective?: Maybe<Objective>;
};

export type CreateParagraphInput = {
  data?: Maybe<ParagraphInput>;
};

export type CreateParagraphPayload = {
  __typename?: 'createParagraphPayload';
  paragraph?: Maybe<Paragraph>;
};

export type CreateReferenceInput = {
  data?: Maybe<ReferenceInput>;
};

export type CreateReferencePayload = {
  __typename?: 'createReferencePayload';
  reference?: Maybe<Reference>;
};

export type CreateReportInput = {
  data?: Maybe<ReportInput>;
};

export type CreateReportPayload = {
  __typename?: 'createReportPayload';
  report?: Maybe<Report>;
};

export type CreateRoleInput = {
  data?: Maybe<RoleInput>;
};

export type CreateRolePayload = {
  __typename?: 'createRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type CreateSectionInput = {
  data?: Maybe<SectionInput>;
};

export type CreateSectionPayload = {
  __typename?: 'createSectionPayload';
  section?: Maybe<Section>;
};

export type CreateSettingInput = {
  data?: Maybe<SettingInput>;
};

export type CreateSettingPayload = {
  __typename?: 'createSettingPayload';
  setting?: Maybe<Setting>;
};

export type CreateStyledTableInput = {
  data?: Maybe<StyledTableInput>;
};

export type CreateStyledTablePayload = {
  __typename?: 'createStyledTablePayload';
  styledTable?: Maybe<StyledTable>;
};

export type CreateSupplementaryInput = {
  data?: Maybe<SupplementaryInput>;
};

export type CreateSupplementaryPayload = {
  __typename?: 'createSupplementaryPayload';
  supplementary?: Maybe<Supplementary>;
};

export type CreateTableInput = {
  data?: Maybe<TableInput>;
};

export type CreateTablePayload = {
  __typename?: 'createTablePayload';
  table?: Maybe<Table>;
};

export type CreateUserInput = {
  data?: Maybe<UserInput>;
};

export type CreateUserPayload = {
  __typename?: 'createUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};



export type DeleteAbbreviationInput = {
  where?: Maybe<InputId>;
};

export type DeleteAbbreviationPayload = {
  __typename?: 'deleteAbbreviationPayload';
  abbreviation?: Maybe<Abbreviation>;
};

export type DeleteChartInput = {
  where?: Maybe<InputId>;
};

export type DeleteChartPayload = {
  __typename?: 'deleteChartPayload';
  chart?: Maybe<Chart>;
};

export type DeleteCountryInput = {
  where?: Maybe<InputId>;
};

export type DeleteCountryPayload = {
  __typename?: 'deleteCountryPayload';
  country?: Maybe<Country>;
};

export type DeleteImageInput = {
  where?: Maybe<InputId>;
};

export type DeleteImagePayload = {
  __typename?: 'deleteImagePayload';
  image?: Maybe<Image>;
};

export type DeleteJobInput = {
  where?: Maybe<InputId>;
};

export type DeleteJobPayload = {
  __typename?: 'deleteJobPayload';
  job?: Maybe<Job>;
};

export type DeleteMasterInfoPayload = {
  __typename?: 'deleteMasterInfoPayload';
  masterInfo?: Maybe<MasterInfo>;
};

export type DeleteObjectiveInput = {
  where?: Maybe<InputId>;
};

export type DeleteObjectivePayload = {
  __typename?: 'deleteObjectivePayload';
  objective?: Maybe<Objective>;
};

export type DeleteParagraphInput = {
  where?: Maybe<InputId>;
};

export type DeleteParagraphPayload = {
  __typename?: 'deleteParagraphPayload';
  paragraph?: Maybe<Paragraph>;
};

export type DeleteReferenceInput = {
  where?: Maybe<InputId>;
};

export type DeleteReferencePayload = {
  __typename?: 'deleteReferencePayload';
  reference?: Maybe<Reference>;
};

export type DeleteReportInput = {
  where?: Maybe<InputId>;
};

export type DeleteReportPayload = {
  __typename?: 'deleteReportPayload';
  report?: Maybe<Report>;
};

export type DeleteRoleInput = {
  where?: Maybe<InputId>;
};

export type DeleteRolePayload = {
  __typename?: 'deleteRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type DeleteSectionInput = {
  where?: Maybe<InputId>;
};

export type DeleteSectionPayload = {
  __typename?: 'deleteSectionPayload';
  section?: Maybe<Section>;
};

export type DeleteSettingInput = {
  where?: Maybe<InputId>;
};

export type DeleteSettingPayload = {
  __typename?: 'deleteSettingPayload';
  setting?: Maybe<Setting>;
};

export type DeleteStyledTableInput = {
  where?: Maybe<InputId>;
};

export type DeleteStyledTablePayload = {
  __typename?: 'deleteStyledTablePayload';
  styledTable?: Maybe<StyledTable>;
};

export type DeleteSupplementaryInput = {
  where?: Maybe<InputId>;
};

export type DeleteSupplementaryPayload = {
  __typename?: 'deleteSupplementaryPayload';
  supplementary?: Maybe<Supplementary>;
};

export type DeleteTableInput = {
  where?: Maybe<InputId>;
};

export type DeleteTablePayload = {
  __typename?: 'deleteTablePayload';
  table?: Maybe<Table>;
};

export type DeleteUserInput = {
  where?: Maybe<InputId>;
};

export type DeleteUserPayload = {
  __typename?: 'deleteUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type EditAbbreviationInput = {
  acronym?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type EditChartInput = {
  title?: Maybe<Scalars['String']>;
  table?: Maybe<Scalars['ID']>;
  number?: Maybe<Scalars['String']>;
};

export type EditComponentReportContentChartInput = {
  id?: Maybe<Scalars['ID']>;
  chart?: Maybe<Scalars['ID']>;
};

export type EditComponentReportContentImageInput = {
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['ID']>;
};

export type EditComponentReportContentParagraphInput = {
  id?: Maybe<Scalars['ID']>;
  paragraph?: Maybe<Scalars['ID']>;
};

export type EditComponentReportContentReferenceInput = {
  id?: Maybe<Scalars['ID']>;
  reference?: Maybe<Scalars['ID']>;
};

export type EditComponentReportContentSectionInput = {
  id?: Maybe<Scalars['ID']>;
  section?: Maybe<Scalars['ID']>;
};

export type EditComponentReportContentStyledTableInput = {
  id?: Maybe<Scalars['ID']>;
  styled_table?: Maybe<Scalars['ID']>;
};

export type EditComponentReportContentTableInput = {
  id?: Maybe<Scalars['ID']>;
  table?: Maybe<Scalars['ID']>;
};

export type EditCountryInput = {
  name?: Maybe<Scalars['String']>;
  partOf?: Maybe<Scalars['String']>;
};

export type EditFileInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash?: Maybe<Scalars['String']>;
  ext?: Maybe<Scalars['String']>;
  mime?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditImageInput = {
  title?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
  section?: Maybe<Scalars['ID']>;
};

export type EditJobInput = {
  report?: Maybe<Scalars['ID']>;
  baseUrl?: Maybe<Scalars['String']>;
};

export type EditMasterInfoInput = {
  title?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type EditObjectiveInput = {
  name?: Maybe<Scalars['String']>;
};

export type EditParagraphInput = {
  title?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
};

export type EditReferenceInput = {
  number?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  fullText?: Maybe<Scalars['ID']>;
  link?: Maybe<Scalars['String']>;
  sections?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditReportInput = {
  title?: Maybe<Scalars['String']>;
  objectives?: Maybe<Array<Maybe<Scalars['ID']>>>;
  countries?: Maybe<Array<Maybe<Scalars['ID']>>>;
  settings?: Maybe<Array<Maybe<Scalars['ID']>>>;
  author?: Maybe<Scalars['ID']>;
  pdf?: Maybe<Scalars['ID']>;
  docx?: Maybe<Scalars['ID']>;
};

export type EditRoleInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditSectionInput = {
  title?: Maybe<Scalars['String']>;
  content?: Maybe<Array<Scalars['SectionContentDynamicZoneInput']>>;
  objectives?: Maybe<Array<Maybe<Scalars['ID']>>>;
  settings?: Maybe<Array<Maybe<Scalars['ID']>>>;
  countries?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sections?: Maybe<Array<Maybe<Scalars['ID']>>>;
  order1?: Maybe<Scalars['Int']>;
  order2?: Maybe<Scalars['Int']>;
  order3?: Maybe<Scalars['Int']>;
  order4?: Maybe<Scalars['Int']>;
  references?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditSettingInput = {
  name?: Maybe<Scalars['String']>;
};

export type EditStyledTableInput = {
  Title?: Maybe<Scalars['String']>;
  contents?: Maybe<Scalars['String']>;
  Footnotes?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
};

export type EditSupplementaryInput = {
  name?: Maybe<Scalars['String']>;
  resource?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditTableInput = {
  name?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
  headers?: Maybe<Scalars['JSON']>;
  groups?: Maybe<Scalars['JSON']>;
  footnotes?: Maybe<Scalars['String']>;
  filterMap?: Maybe<Scalars['JSON']>;
  subgroups?: Maybe<Scalars['JSON']>;
  number?: Maybe<Scalars['String']>;
};

export type EditUserInput = {
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  reports?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type FileInput = {
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ForgotPassword = {
  __typename?: 'ForgotPassword';
  ok?: Maybe<Scalars['Boolean']>;
};

export type Image = {
  __typename?: 'Image';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  title?: Maybe<Scalars['String']>;
  image?: Maybe<UploadFile>;
  section?: Maybe<Section>;
};

export type ImageAggregator = {
  __typename?: 'ImageAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ImageConnection = {
  __typename?: 'ImageConnection';
  values?: Maybe<Array<Maybe<Image>>>;
  groupBy?: Maybe<ImageGroupBy>;
  aggregate?: Maybe<ImageAggregator>;
};

export type ImageConnection_Id = {
  __typename?: 'ImageConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ImageConnection>;
};

export type ImageConnectionCreatedAt = {
  __typename?: 'ImageConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ImageConnection>;
};

export type ImageConnectionId = {
  __typename?: 'ImageConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ImageConnection>;
};

export type ImageConnectionImage = {
  __typename?: 'ImageConnectionImage';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ImageConnection>;
};

export type ImageConnectionSection = {
  __typename?: 'ImageConnectionSection';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ImageConnection>;
};

export type ImageConnectionTitle = {
  __typename?: 'ImageConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ImageConnection>;
};

export type ImageConnectionUpdatedAt = {
  __typename?: 'ImageConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ImageConnection>;
};

export type ImageGroupBy = {
  __typename?: 'ImageGroupBy';
  id?: Maybe<Array<Maybe<ImageConnectionId>>>;
  _id?: Maybe<Array<Maybe<ImageConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<ImageConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<ImageConnectionUpdatedAt>>>;
  title?: Maybe<Array<Maybe<ImageConnectionTitle>>>;
  image?: Maybe<Array<Maybe<ImageConnectionImage>>>;
  section?: Maybe<Array<Maybe<ImageConnectionSection>>>;
};

export type ImageInput = {
  title?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
  section?: Maybe<Scalars['ID']>;
};

export type InputId = {
  id: Scalars['ID'];
};

export type Job = {
  __typename?: 'Job';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  report?: Maybe<Report>;
  baseUrl: Scalars['String'];
};

export type JobAggregator = {
  __typename?: 'JobAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type JobConnection = {
  __typename?: 'JobConnection';
  values?: Maybe<Array<Maybe<Job>>>;
  groupBy?: Maybe<JobGroupBy>;
  aggregate?: Maybe<JobAggregator>;
};

export type JobConnection_Id = {
  __typename?: 'JobConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<JobConnection>;
};

export type JobConnectionBaseUrl = {
  __typename?: 'JobConnectionBaseUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<JobConnection>;
};

export type JobConnectionCreatedAt = {
  __typename?: 'JobConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<JobConnection>;
};

export type JobConnectionId = {
  __typename?: 'JobConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<JobConnection>;
};

export type JobConnectionReport = {
  __typename?: 'JobConnectionReport';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<JobConnection>;
};

export type JobConnectionUpdatedAt = {
  __typename?: 'JobConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<JobConnection>;
};

export type JobGroupBy = {
  __typename?: 'JobGroupBy';
  id?: Maybe<Array<Maybe<JobConnectionId>>>;
  _id?: Maybe<Array<Maybe<JobConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<JobConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<JobConnectionUpdatedAt>>>;
  report?: Maybe<Array<Maybe<JobConnectionReport>>>;
  baseUrl?: Maybe<Array<Maybe<JobConnectionBaseUrl>>>;
};

export type JobInput = {
  report?: Maybe<Scalars['ID']>;
  baseUrl: Scalars['String'];
};



export type MasterInfo = {
  __typename?: 'MasterInfo';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  title: Scalars['String'];
  version: Scalars['String'];
};

export type MasterInfoInput = {
  title: Scalars['String'];
  version: Scalars['String'];
};

export type Morph = UsersPermissionsMe | UsersPermissionsMeRole | UsersPermissionsLoginPayload | ForgotPassword | Abbreviation | AbbreviationConnection | AbbreviationAggregator | AbbreviationGroupBy | AbbreviationConnectionId | AbbreviationConnection_Id | AbbreviationConnectionCreatedAt | AbbreviationConnectionUpdatedAt | AbbreviationConnectionAcronym | AbbreviationConnectionDescription | CreateAbbreviationPayload | UpdateAbbreviationPayload | DeleteAbbreviationPayload | Chart | ChartConnection | ChartAggregator | ChartGroupBy | ChartConnectionId | ChartConnection_Id | ChartConnectionCreatedAt | ChartConnectionUpdatedAt | ChartConnectionTitle | ChartConnectionTable | ChartConnectionNumber | CreateChartPayload | UpdateChartPayload | DeleteChartPayload | Country | CountryConnection | CountryAggregator | CountryGroupBy | CountryConnectionId | CountryConnection_Id | CountryConnectionCreatedAt | CountryConnectionUpdatedAt | CountryConnectionName | CountryConnectionPartOf | CreateCountryPayload | UpdateCountryPayload | DeleteCountryPayload | Image | ImageConnection | ImageAggregator | ImageGroupBy | ImageConnectionId | ImageConnection_Id | ImageConnectionCreatedAt | ImageConnectionUpdatedAt | ImageConnectionTitle | ImageConnectionImage | ImageConnectionSection | CreateImagePayload | UpdateImagePayload | DeleteImagePayload | Job | JobConnection | JobAggregator | JobGroupBy | JobConnectionId | JobConnection_Id | JobConnectionCreatedAt | JobConnectionUpdatedAt | JobConnectionReport | JobConnectionBaseUrl | CreateJobPayload | UpdateJobPayload | DeleteJobPayload | MasterInfo | UpdateMasterInfoPayload | DeleteMasterInfoPayload | Objective | ObjectiveConnection | ObjectiveAggregator | ObjectiveGroupBy | ObjectiveConnectionId | ObjectiveConnection_Id | ObjectiveConnectionCreatedAt | ObjectiveConnectionUpdatedAt | ObjectiveConnectionName | CreateObjectivePayload | UpdateObjectivePayload | DeleteObjectivePayload | Paragraph | ParagraphConnection | ParagraphAggregator | ParagraphGroupBy | ParagraphConnectionId | ParagraphConnection_Id | ParagraphConnectionCreatedAt | ParagraphConnectionUpdatedAt | ParagraphConnectionTitle | ParagraphConnectionBody | CreateParagraphPayload | UpdateParagraphPayload | DeleteParagraphPayload | Reference | ReferenceConnection | ReferenceAggregator | ReferenceAggregatorSum | ReferenceAggregatorAvg | ReferenceAggregatorMin | ReferenceAggregatorMax | ReferenceGroupBy | ReferenceConnectionId | ReferenceConnection_Id | ReferenceConnectionCreatedAt | ReferenceConnectionUpdatedAt | ReferenceConnectionNumber | ReferenceConnectionDescription | ReferenceConnectionFullText | ReferenceConnectionLink | CreateReferencePayload | UpdateReferencePayload | DeleteReferencePayload | Report | ReportConnection | ReportAggregator | ReportGroupBy | ReportConnectionId | ReportConnection_Id | ReportConnectionCreatedAt | ReportConnectionUpdatedAt | ReportConnectionTitle | ReportConnectionAuthor | ReportConnectionPdf | ReportConnectionDocx | CreateReportPayload | UpdateReportPayload | DeleteReportPayload | Section | SectionConnection | SectionAggregator | SectionAggregatorSum | SectionAggregatorAvg | SectionAggregatorMin | SectionAggregatorMax | SectionGroupBy | SectionConnectionId | SectionConnection_Id | SectionConnectionCreatedAt | SectionConnectionUpdatedAt | SectionConnectionTitle | SectionConnectionOrder1 | SectionConnectionOrder2 | SectionConnectionOrder3 | SectionConnectionOrder4 | CreateSectionPayload | UpdateSectionPayload | DeleteSectionPayload | Setting | SettingConnection | SettingAggregator | SettingGroupBy | SettingConnectionId | SettingConnection_Id | SettingConnectionCreatedAt | SettingConnectionUpdatedAt | SettingConnectionName | CreateSettingPayload | UpdateSettingPayload | DeleteSettingPayload | StyledTable | StyledTableConnection | StyledTableAggregator | StyledTableGroupBy | StyledTableConnectionId | StyledTableConnection_Id | StyledTableConnectionCreatedAt | StyledTableConnectionUpdatedAt | StyledTableConnectionTitle | StyledTableConnectionContents | StyledTableConnectionFootnotes | StyledTableConnectionNumber | CreateStyledTablePayload | UpdateStyledTablePayload | DeleteStyledTablePayload | Supplementary | SupplementaryConnection | SupplementaryAggregator | SupplementaryGroupBy | SupplementaryConnectionId | SupplementaryConnection_Id | SupplementaryConnectionCreatedAt | SupplementaryConnectionUpdatedAt | SupplementaryConnectionName | CreateSupplementaryPayload | UpdateSupplementaryPayload | DeleteSupplementaryPayload | Table | TableConnection | TableAggregator | TableGroupBy | TableConnectionId | TableConnection_Id | TableConnectionCreatedAt | TableConnectionUpdatedAt | TableConnectionName | TableConnectionData | TableConnectionHeaders | TableConnectionGroups | TableConnectionFootnotes | TableConnectionFilterMap | TableConnectionSubgroups | TableConnectionNumber | CreateTablePayload | UpdateTablePayload | DeleteTablePayload | UploadFile | UploadFileConnection | UploadFileAggregator | UploadFileAggregatorSum | UploadFileAggregatorAvg | UploadFileAggregatorMin | UploadFileAggregatorMax | UploadFileGroupBy | UploadFileConnectionId | UploadFileConnection_Id | UploadFileConnectionCreatedAt | UploadFileConnectionUpdatedAt | UploadFileConnectionName | UploadFileConnectionAlternativeText | UploadFileConnectionCaption | UploadFileConnectionWidth | UploadFileConnectionHeight | UploadFileConnectionFormats | UploadFileConnectionHash | UploadFileConnectionExt | UploadFileConnectionMime | UploadFileConnectionSize | UploadFileConnectionUrl | UploadFileConnectionPreviewUrl | UploadFileConnectionProvider | UploadFileConnectionProvider_Metadata | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsRoleConnection | UsersPermissionsRoleAggregator | UsersPermissionsRoleGroupBy | UsersPermissionsRoleConnectionId | UsersPermissionsRoleConnection_Id | UsersPermissionsRoleConnectionCreatedAt | UsersPermissionsRoleConnectionUpdatedAt | UsersPermissionsRoleConnectionName | UsersPermissionsRoleConnectionDescription | UsersPermissionsRoleConnectionType | CreateRolePayload | UpdateRolePayload | DeleteRolePayload | UsersPermissionsUser | UsersPermissionsUserConnection | UsersPermissionsUserAggregator | UsersPermissionsUserGroupBy | UsersPermissionsUserConnectionId | UsersPermissionsUserConnection_Id | UsersPermissionsUserConnectionCreatedAt | UsersPermissionsUserConnectionUpdatedAt | UsersPermissionsUserConnectionUsername | UsersPermissionsUserConnectionEmail | UsersPermissionsUserConnectionProvider | UsersPermissionsUserConnectionConfirmed | UsersPermissionsUserConnectionBlocked | UsersPermissionsUserConnectionRole | CreateUserPayload | UpdateUserPayload | DeleteUserPayload | ComponentReportContentChart | ComponentReportContentImage | ComponentReportContentParagraph | ComponentReportContentReference | ComponentReportContentSection | ComponentReportContentStyledTable | ComponentReportContentTable;

export type Mutation = {
  __typename?: 'Mutation';
  createAbbreviation?: Maybe<CreateAbbreviationPayload>;
  updateAbbreviation?: Maybe<UpdateAbbreviationPayload>;
  deleteAbbreviation?: Maybe<DeleteAbbreviationPayload>;
  createChart?: Maybe<CreateChartPayload>;
  updateChart?: Maybe<UpdateChartPayload>;
  deleteChart?: Maybe<DeleteChartPayload>;
  createCountry?: Maybe<CreateCountryPayload>;
  updateCountry?: Maybe<UpdateCountryPayload>;
  deleteCountry?: Maybe<DeleteCountryPayload>;
  createImage?: Maybe<CreateImagePayload>;
  updateImage?: Maybe<UpdateImagePayload>;
  deleteImage?: Maybe<DeleteImagePayload>;
  createJob?: Maybe<CreateJobPayload>;
  updateJob?: Maybe<UpdateJobPayload>;
  deleteJob?: Maybe<DeleteJobPayload>;
  updateMasterInfo?: Maybe<UpdateMasterInfoPayload>;
  deleteMasterInfo?: Maybe<DeleteMasterInfoPayload>;
  createObjective?: Maybe<CreateObjectivePayload>;
  updateObjective?: Maybe<UpdateObjectivePayload>;
  deleteObjective?: Maybe<DeleteObjectivePayload>;
  createParagraph?: Maybe<CreateParagraphPayload>;
  updateParagraph?: Maybe<UpdateParagraphPayload>;
  deleteParagraph?: Maybe<DeleteParagraphPayload>;
  createReference?: Maybe<CreateReferencePayload>;
  updateReference?: Maybe<UpdateReferencePayload>;
  deleteReference?: Maybe<DeleteReferencePayload>;
  createReport?: Maybe<CreateReportPayload>;
  updateReport?: Maybe<UpdateReportPayload>;
  deleteReport?: Maybe<DeleteReportPayload>;
  createSection?: Maybe<CreateSectionPayload>;
  updateSection?: Maybe<UpdateSectionPayload>;
  deleteSection?: Maybe<DeleteSectionPayload>;
  createSetting?: Maybe<CreateSettingPayload>;
  updateSetting?: Maybe<UpdateSettingPayload>;
  deleteSetting?: Maybe<DeleteSettingPayload>;
  createStyledTable?: Maybe<CreateStyledTablePayload>;
  updateStyledTable?: Maybe<UpdateStyledTablePayload>;
  deleteStyledTable?: Maybe<DeleteStyledTablePayload>;
  createSupplementary?: Maybe<CreateSupplementaryPayload>;
  updateSupplementary?: Maybe<UpdateSupplementaryPayload>;
  deleteSupplementary?: Maybe<DeleteSupplementaryPayload>;
  createTable?: Maybe<CreateTablePayload>;
  updateTable?: Maybe<UpdateTablePayload>;
  deleteTable?: Maybe<DeleteTablePayload>;
  /** Create a new role */
  createRole?: Maybe<CreateRolePayload>;
  /** Update an existing role */
  updateRole?: Maybe<UpdateRolePayload>;
  /** Delete an existing role */
  deleteRole?: Maybe<DeleteRolePayload>;
  /** Create a new user */
  createUser?: Maybe<CreateUserPayload>;
  /** Update an existing user */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Delete an existing user */
  deleteUser?: Maybe<DeleteUserPayload>;
  upload: UploadFile;
  multipleUpload: Array<Maybe<UploadFile>>;
  login: UsersPermissionsLoginPayload;
  register: UsersPermissionsLoginPayload;
  forgotPassword?: Maybe<ForgotPassword>;
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
};


export type MutationCreateAbbreviationArgs = {
  input?: Maybe<CreateAbbreviationInput>;
};


export type MutationUpdateAbbreviationArgs = {
  input?: Maybe<UpdateAbbreviationInput>;
};


export type MutationDeleteAbbreviationArgs = {
  input?: Maybe<DeleteAbbreviationInput>;
};


export type MutationCreateChartArgs = {
  input?: Maybe<CreateChartInput>;
};


export type MutationUpdateChartArgs = {
  input?: Maybe<UpdateChartInput>;
};


export type MutationDeleteChartArgs = {
  input?: Maybe<DeleteChartInput>;
};


export type MutationCreateCountryArgs = {
  input?: Maybe<CreateCountryInput>;
};


export type MutationUpdateCountryArgs = {
  input?: Maybe<UpdateCountryInput>;
};


export type MutationDeleteCountryArgs = {
  input?: Maybe<DeleteCountryInput>;
};


export type MutationCreateImageArgs = {
  input?: Maybe<CreateImageInput>;
};


export type MutationUpdateImageArgs = {
  input?: Maybe<UpdateImageInput>;
};


export type MutationDeleteImageArgs = {
  input?: Maybe<DeleteImageInput>;
};


export type MutationCreateJobArgs = {
  input?: Maybe<CreateJobInput>;
};


export type MutationUpdateJobArgs = {
  input?: Maybe<UpdateJobInput>;
};


export type MutationDeleteJobArgs = {
  input?: Maybe<DeleteJobInput>;
};


export type MutationUpdateMasterInfoArgs = {
  input?: Maybe<UpdateMasterInfoInput>;
};


export type MutationCreateObjectiveArgs = {
  input?: Maybe<CreateObjectiveInput>;
};


export type MutationUpdateObjectiveArgs = {
  input?: Maybe<UpdateObjectiveInput>;
};


export type MutationDeleteObjectiveArgs = {
  input?: Maybe<DeleteObjectiveInput>;
};


export type MutationCreateParagraphArgs = {
  input?: Maybe<CreateParagraphInput>;
};


export type MutationUpdateParagraphArgs = {
  input?: Maybe<UpdateParagraphInput>;
};


export type MutationDeleteParagraphArgs = {
  input?: Maybe<DeleteParagraphInput>;
};


export type MutationCreateReferenceArgs = {
  input?: Maybe<CreateReferenceInput>;
};


export type MutationUpdateReferenceArgs = {
  input?: Maybe<UpdateReferenceInput>;
};


export type MutationDeleteReferenceArgs = {
  input?: Maybe<DeleteReferenceInput>;
};


export type MutationCreateReportArgs = {
  input?: Maybe<CreateReportInput>;
};


export type MutationUpdateReportArgs = {
  input?: Maybe<UpdateReportInput>;
};


export type MutationDeleteReportArgs = {
  input?: Maybe<DeleteReportInput>;
};


export type MutationCreateSectionArgs = {
  input?: Maybe<CreateSectionInput>;
};


export type MutationUpdateSectionArgs = {
  input?: Maybe<UpdateSectionInput>;
};


export type MutationDeleteSectionArgs = {
  input?: Maybe<DeleteSectionInput>;
};


export type MutationCreateSettingArgs = {
  input?: Maybe<CreateSettingInput>;
};


export type MutationUpdateSettingArgs = {
  input?: Maybe<UpdateSettingInput>;
};


export type MutationDeleteSettingArgs = {
  input?: Maybe<DeleteSettingInput>;
};


export type MutationCreateStyledTableArgs = {
  input?: Maybe<CreateStyledTableInput>;
};


export type MutationUpdateStyledTableArgs = {
  input?: Maybe<UpdateStyledTableInput>;
};


export type MutationDeleteStyledTableArgs = {
  input?: Maybe<DeleteStyledTableInput>;
};


export type MutationCreateSupplementaryArgs = {
  input?: Maybe<CreateSupplementaryInput>;
};


export type MutationUpdateSupplementaryArgs = {
  input?: Maybe<UpdateSupplementaryInput>;
};


export type MutationDeleteSupplementaryArgs = {
  input?: Maybe<DeleteSupplementaryInput>;
};


export type MutationCreateTableArgs = {
  input?: Maybe<CreateTableInput>;
};


export type MutationUpdateTableArgs = {
  input?: Maybe<UpdateTableInput>;
};


export type MutationDeleteTableArgs = {
  input?: Maybe<DeleteTableInput>;
};


export type MutationCreateRoleArgs = {
  input?: Maybe<CreateRoleInput>;
};


export type MutationUpdateRoleArgs = {
  input?: Maybe<UpdateRoleInput>;
};


export type MutationDeleteRoleArgs = {
  input?: Maybe<DeleteRoleInput>;
};


export type MutationCreateUserArgs = {
  input?: Maybe<CreateUserInput>;
};


export type MutationUpdateUserArgs = {
  input?: Maybe<UpdateUserInput>;
};


export type MutationDeleteUserArgs = {
  input?: Maybe<DeleteUserInput>;
};


export type MutationUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  file: Scalars['Upload'];
};


export type MutationMultipleUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  files: Array<Maybe<Scalars['Upload']>>;
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationRegisterArgs = {
  input: UserInput;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationChangePasswordArgs = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  code: Scalars['String'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};

export type Objective = {
  __typename?: 'Objective';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
};

export type ObjectiveAggregator = {
  __typename?: 'ObjectiveAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ObjectiveConnection = {
  __typename?: 'ObjectiveConnection';
  values?: Maybe<Array<Maybe<Objective>>>;
  groupBy?: Maybe<ObjectiveGroupBy>;
  aggregate?: Maybe<ObjectiveAggregator>;
};

export type ObjectiveConnection_Id = {
  __typename?: 'ObjectiveConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ObjectiveConnection>;
};

export type ObjectiveConnectionCreatedAt = {
  __typename?: 'ObjectiveConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ObjectiveConnection>;
};

export type ObjectiveConnectionId = {
  __typename?: 'ObjectiveConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ObjectiveConnection>;
};

export type ObjectiveConnectionName = {
  __typename?: 'ObjectiveConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ObjectiveConnection>;
};

export type ObjectiveConnectionUpdatedAt = {
  __typename?: 'ObjectiveConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ObjectiveConnection>;
};

export type ObjectiveGroupBy = {
  __typename?: 'ObjectiveGroupBy';
  id?: Maybe<Array<Maybe<ObjectiveConnectionId>>>;
  _id?: Maybe<Array<Maybe<ObjectiveConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<ObjectiveConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<ObjectiveConnectionUpdatedAt>>>;
  name?: Maybe<Array<Maybe<ObjectiveConnectionName>>>;
};

export type ObjectiveInput = {
  name: Scalars['String'];
};

export type Paragraph = {
  __typename?: 'Paragraph';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  title?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
};

export type ParagraphAggregator = {
  __typename?: 'ParagraphAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ParagraphConnection = {
  __typename?: 'ParagraphConnection';
  values?: Maybe<Array<Maybe<Paragraph>>>;
  groupBy?: Maybe<ParagraphGroupBy>;
  aggregate?: Maybe<ParagraphAggregator>;
};

export type ParagraphConnection_Id = {
  __typename?: 'ParagraphConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ParagraphConnection>;
};

export type ParagraphConnectionBody = {
  __typename?: 'ParagraphConnectionBody';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ParagraphConnection>;
};

export type ParagraphConnectionCreatedAt = {
  __typename?: 'ParagraphConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ParagraphConnection>;
};

export type ParagraphConnectionId = {
  __typename?: 'ParagraphConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ParagraphConnection>;
};

export type ParagraphConnectionTitle = {
  __typename?: 'ParagraphConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ParagraphConnection>;
};

export type ParagraphConnectionUpdatedAt = {
  __typename?: 'ParagraphConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ParagraphConnection>;
};

export type ParagraphGroupBy = {
  __typename?: 'ParagraphGroupBy';
  id?: Maybe<Array<Maybe<ParagraphConnectionId>>>;
  _id?: Maybe<Array<Maybe<ParagraphConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<ParagraphConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<ParagraphConnectionUpdatedAt>>>;
  title?: Maybe<Array<Maybe<ParagraphConnectionTitle>>>;
  body?: Maybe<Array<Maybe<ParagraphConnectionBody>>>;
};

export type ParagraphInput = {
  title?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  abbreviation?: Maybe<Abbreviation>;
  abbreviations?: Maybe<Array<Maybe<Abbreviation>>>;
  abbreviationsConnection?: Maybe<AbbreviationConnection>;
  chart?: Maybe<Chart>;
  charts?: Maybe<Array<Maybe<Chart>>>;
  chartsConnection?: Maybe<ChartConnection>;
  country?: Maybe<Country>;
  countries?: Maybe<Array<Maybe<Country>>>;
  countriesConnection?: Maybe<CountryConnection>;
  image?: Maybe<Image>;
  images?: Maybe<Array<Maybe<Image>>>;
  imagesConnection?: Maybe<ImageConnection>;
  job?: Maybe<Job>;
  jobs?: Maybe<Array<Maybe<Job>>>;
  jobsConnection?: Maybe<JobConnection>;
  masterInfo?: Maybe<MasterInfo>;
  objective?: Maybe<Objective>;
  objectives?: Maybe<Array<Maybe<Objective>>>;
  objectivesConnection?: Maybe<ObjectiveConnection>;
  paragraph?: Maybe<Paragraph>;
  paragraphs?: Maybe<Array<Maybe<Paragraph>>>;
  paragraphsConnection?: Maybe<ParagraphConnection>;
  reference?: Maybe<Reference>;
  references?: Maybe<Array<Maybe<Reference>>>;
  referencesConnection?: Maybe<ReferenceConnection>;
  report?: Maybe<Report>;
  reports?: Maybe<Array<Maybe<Report>>>;
  reportsConnection?: Maybe<ReportConnection>;
  section?: Maybe<Section>;
  sections?: Maybe<Array<Maybe<Section>>>;
  sectionsConnection?: Maybe<SectionConnection>;
  setting?: Maybe<Setting>;
  settings?: Maybe<Array<Maybe<Setting>>>;
  settingsConnection?: Maybe<SettingConnection>;
  styledTable?: Maybe<StyledTable>;
  styledTables?: Maybe<Array<Maybe<StyledTable>>>;
  styledTablesConnection?: Maybe<StyledTableConnection>;
  supplementary?: Maybe<Supplementary>;
  supplementaries?: Maybe<Array<Maybe<Supplementary>>>;
  supplementariesConnection?: Maybe<SupplementaryConnection>;
  table?: Maybe<Table>;
  tables?: Maybe<Array<Maybe<Table>>>;
  tablesConnection?: Maybe<TableConnection>;
  files?: Maybe<Array<Maybe<UploadFile>>>;
  filesConnection?: Maybe<UploadFileConnection>;
  role?: Maybe<UsersPermissionsRole>;
  /** Retrieve all the existing roles. You can't apply filters on this query. */
  roles?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  rolesConnection?: Maybe<UsersPermissionsRoleConnection>;
  user?: Maybe<UsersPermissionsUser>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  usersConnection?: Maybe<UsersPermissionsUserConnection>;
  me?: Maybe<UsersPermissionsMe>;
};


export type QueryAbbreviationArgs = {
  id: Scalars['ID'];
};


export type QueryAbbreviationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryAbbreviationsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryChartArgs = {
  id: Scalars['ID'];
};


export type QueryChartsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryChartsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCountryArgs = {
  id: Scalars['ID'];
};


export type QueryCountriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCountriesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryImageArgs = {
  id: Scalars['ID'];
};


export type QueryImagesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryImagesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryJobArgs = {
  id: Scalars['ID'];
};


export type QueryJobsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryJobsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryObjectiveArgs = {
  id: Scalars['ID'];
};


export type QueryObjectivesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryObjectivesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryParagraphArgs = {
  id: Scalars['ID'];
};


export type QueryParagraphsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryParagraphsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryReferenceArgs = {
  id: Scalars['ID'];
};


export type QueryReferencesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryReferencesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryReportArgs = {
  id: Scalars['ID'];
};


export type QueryReportsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryReportsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySectionArgs = {
  id: Scalars['ID'];
};


export type QuerySectionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySectionsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySettingArgs = {
  id: Scalars['ID'];
};


export type QuerySettingsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySettingsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryStyledTableArgs = {
  id: Scalars['ID'];
};


export type QueryStyledTablesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryStyledTablesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySupplementaryArgs = {
  id: Scalars['ID'];
};


export type QuerySupplementariesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySupplementariesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTableArgs = {
  id: Scalars['ID'];
};


export type QueryTablesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTablesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFilesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFilesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRoleArgs = {
  id: Scalars['ID'];
};


export type QueryRolesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRolesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUsersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type Reference = {
  __typename?: 'Reference';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  number: Scalars['Int'];
  description: Scalars['String'];
  fullText?: Maybe<UploadFile>;
  link?: Maybe<Scalars['String']>;
  sections?: Maybe<Array<Maybe<Section>>>;
};


export type ReferenceSectionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ReferenceAggregator = {
  __typename?: 'ReferenceAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<ReferenceAggregatorSum>;
  avg?: Maybe<ReferenceAggregatorAvg>;
  min?: Maybe<ReferenceAggregatorMin>;
  max?: Maybe<ReferenceAggregatorMax>;
};

export type ReferenceAggregatorAvg = {
  __typename?: 'ReferenceAggregatorAvg';
  number?: Maybe<Scalars['Float']>;
};

export type ReferenceAggregatorMax = {
  __typename?: 'ReferenceAggregatorMax';
  number?: Maybe<Scalars['Float']>;
};

export type ReferenceAggregatorMin = {
  __typename?: 'ReferenceAggregatorMin';
  number?: Maybe<Scalars['Float']>;
};

export type ReferenceAggregatorSum = {
  __typename?: 'ReferenceAggregatorSum';
  number?: Maybe<Scalars['Float']>;
};

export type ReferenceConnection = {
  __typename?: 'ReferenceConnection';
  values?: Maybe<Array<Maybe<Reference>>>;
  groupBy?: Maybe<ReferenceGroupBy>;
  aggregate?: Maybe<ReferenceAggregator>;
};

export type ReferenceConnection_Id = {
  __typename?: 'ReferenceConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReferenceConnection>;
};

export type ReferenceConnectionCreatedAt = {
  __typename?: 'ReferenceConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ReferenceConnection>;
};

export type ReferenceConnectionDescription = {
  __typename?: 'ReferenceConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ReferenceConnection>;
};

export type ReferenceConnectionFullText = {
  __typename?: 'ReferenceConnectionFullText';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReferenceConnection>;
};

export type ReferenceConnectionId = {
  __typename?: 'ReferenceConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReferenceConnection>;
};

export type ReferenceConnectionLink = {
  __typename?: 'ReferenceConnectionLink';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ReferenceConnection>;
};

export type ReferenceConnectionNumber = {
  __typename?: 'ReferenceConnectionNumber';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<ReferenceConnection>;
};

export type ReferenceConnectionUpdatedAt = {
  __typename?: 'ReferenceConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ReferenceConnection>;
};

export type ReferenceGroupBy = {
  __typename?: 'ReferenceGroupBy';
  id?: Maybe<Array<Maybe<ReferenceConnectionId>>>;
  _id?: Maybe<Array<Maybe<ReferenceConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<ReferenceConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<ReferenceConnectionUpdatedAt>>>;
  number?: Maybe<Array<Maybe<ReferenceConnectionNumber>>>;
  description?: Maybe<Array<Maybe<ReferenceConnectionDescription>>>;
  fullText?: Maybe<Array<Maybe<ReferenceConnectionFullText>>>;
  link?: Maybe<Array<Maybe<ReferenceConnectionLink>>>;
};

export type ReferenceInput = {
  number: Scalars['Int'];
  description: Scalars['String'];
  fullText?: Maybe<Scalars['ID']>;
  link?: Maybe<Scalars['String']>;
  sections?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type Report = {
  __typename?: 'Report';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  title?: Maybe<Scalars['String']>;
  author?: Maybe<UsersPermissionsUser>;
  pdf?: Maybe<UploadFile>;
  docx?: Maybe<UploadFile>;
  objectives?: Maybe<Array<Maybe<Objective>>>;
  countries?: Maybe<Array<Maybe<Country>>>;
  settings?: Maybe<Array<Maybe<Setting>>>;
};


export type ReportObjectivesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ReportCountriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ReportSettingsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ReportAggregator = {
  __typename?: 'ReportAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ReportConnection = {
  __typename?: 'ReportConnection';
  values?: Maybe<Array<Maybe<Report>>>;
  groupBy?: Maybe<ReportGroupBy>;
  aggregate?: Maybe<ReportAggregator>;
};

export type ReportConnection_Id = {
  __typename?: 'ReportConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionAuthor = {
  __typename?: 'ReportConnectionAuthor';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionCreatedAt = {
  __typename?: 'ReportConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionDocx = {
  __typename?: 'ReportConnectionDocx';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionId = {
  __typename?: 'ReportConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionPdf = {
  __typename?: 'ReportConnectionPdf';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionTitle = {
  __typename?: 'ReportConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionUpdatedAt = {
  __typename?: 'ReportConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportGroupBy = {
  __typename?: 'ReportGroupBy';
  id?: Maybe<Array<Maybe<ReportConnectionId>>>;
  _id?: Maybe<Array<Maybe<ReportConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<ReportConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<ReportConnectionUpdatedAt>>>;
  title?: Maybe<Array<Maybe<ReportConnectionTitle>>>;
  author?: Maybe<Array<Maybe<ReportConnectionAuthor>>>;
  pdf?: Maybe<Array<Maybe<ReportConnectionPdf>>>;
  docx?: Maybe<Array<Maybe<ReportConnectionDocx>>>;
};

export type ReportInput = {
  title?: Maybe<Scalars['String']>;
  objectives?: Maybe<Array<Maybe<Scalars['ID']>>>;
  countries?: Maybe<Array<Maybe<Scalars['ID']>>>;
  settings?: Maybe<Array<Maybe<Scalars['ID']>>>;
  author?: Maybe<Scalars['ID']>;
  pdf?: Maybe<Scalars['ID']>;
  docx?: Maybe<Scalars['ID']>;
};

export type RoleInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type Section = {
  __typename?: 'Section';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  title: Scalars['String'];
  content?: Maybe<Array<Maybe<SectionContentDynamicZone>>>;
  order1?: Maybe<Scalars['Int']>;
  order2?: Maybe<Scalars['Int']>;
  order3?: Maybe<Scalars['Int']>;
  order4?: Maybe<Scalars['Int']>;
  objectives?: Maybe<Array<Maybe<Objective>>>;
  settings?: Maybe<Array<Maybe<Setting>>>;
  countries?: Maybe<Array<Maybe<Country>>>;
  sections?: Maybe<Array<Maybe<Section>>>;
  references?: Maybe<Array<Maybe<Reference>>>;
};


export type SectionObjectivesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type SectionSettingsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type SectionCountriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type SectionSectionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type SectionReferencesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type SectionAggregator = {
  __typename?: 'SectionAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<SectionAggregatorSum>;
  avg?: Maybe<SectionAggregatorAvg>;
  min?: Maybe<SectionAggregatorMin>;
  max?: Maybe<SectionAggregatorMax>;
};

export type SectionAggregatorAvg = {
  __typename?: 'SectionAggregatorAvg';
  order1?: Maybe<Scalars['Float']>;
  order2?: Maybe<Scalars['Float']>;
  order3?: Maybe<Scalars['Float']>;
  order4?: Maybe<Scalars['Float']>;
};

export type SectionAggregatorMax = {
  __typename?: 'SectionAggregatorMax';
  order1?: Maybe<Scalars['Float']>;
  order2?: Maybe<Scalars['Float']>;
  order3?: Maybe<Scalars['Float']>;
  order4?: Maybe<Scalars['Float']>;
};

export type SectionAggregatorMin = {
  __typename?: 'SectionAggregatorMin';
  order1?: Maybe<Scalars['Float']>;
  order2?: Maybe<Scalars['Float']>;
  order3?: Maybe<Scalars['Float']>;
  order4?: Maybe<Scalars['Float']>;
};

export type SectionAggregatorSum = {
  __typename?: 'SectionAggregatorSum';
  order1?: Maybe<Scalars['Float']>;
  order2?: Maybe<Scalars['Float']>;
  order3?: Maybe<Scalars['Float']>;
  order4?: Maybe<Scalars['Float']>;
};

export type SectionConnection = {
  __typename?: 'SectionConnection';
  values?: Maybe<Array<Maybe<Section>>>;
  groupBy?: Maybe<SectionGroupBy>;
  aggregate?: Maybe<SectionAggregator>;
};

export type SectionConnection_Id = {
  __typename?: 'SectionConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionCreatedAt = {
  __typename?: 'SectionConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionId = {
  __typename?: 'SectionConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionOrder1 = {
  __typename?: 'SectionConnectionOrder1';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionOrder2 = {
  __typename?: 'SectionConnectionOrder2';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionOrder3 = {
  __typename?: 'SectionConnectionOrder3';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionOrder4 = {
  __typename?: 'SectionConnectionOrder4';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionTitle = {
  __typename?: 'SectionConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionConnectionUpdatedAt = {
  __typename?: 'SectionConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SectionConnection>;
};

export type SectionContentDynamicZone = ComponentReportContentChart | ComponentReportContentImage | ComponentReportContentParagraph | ComponentReportContentTable | ComponentReportContentStyledTable;


export type SectionGroupBy = {
  __typename?: 'SectionGroupBy';
  id?: Maybe<Array<Maybe<SectionConnectionId>>>;
  _id?: Maybe<Array<Maybe<SectionConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<SectionConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<SectionConnectionUpdatedAt>>>;
  title?: Maybe<Array<Maybe<SectionConnectionTitle>>>;
  order1?: Maybe<Array<Maybe<SectionConnectionOrder1>>>;
  order2?: Maybe<Array<Maybe<SectionConnectionOrder2>>>;
  order3?: Maybe<Array<Maybe<SectionConnectionOrder3>>>;
  order4?: Maybe<Array<Maybe<SectionConnectionOrder4>>>;
};

export type SectionInput = {
  title: Scalars['String'];
  content?: Maybe<Array<Scalars['SectionContentDynamicZoneInput']>>;
  objectives?: Maybe<Array<Maybe<Scalars['ID']>>>;
  settings?: Maybe<Array<Maybe<Scalars['ID']>>>;
  countries?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sections?: Maybe<Array<Maybe<Scalars['ID']>>>;
  order1?: Maybe<Scalars['Int']>;
  order2?: Maybe<Scalars['Int']>;
  order3?: Maybe<Scalars['Int']>;
  order4?: Maybe<Scalars['Int']>;
  references?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type Setting = {
  __typename?: 'Setting';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
};

export type SettingAggregator = {
  __typename?: 'SettingAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SettingConnection = {
  __typename?: 'SettingConnection';
  values?: Maybe<Array<Maybe<Setting>>>;
  groupBy?: Maybe<SettingGroupBy>;
  aggregate?: Maybe<SettingAggregator>;
};

export type SettingConnection_Id = {
  __typename?: 'SettingConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SettingConnection>;
};

export type SettingConnectionCreatedAt = {
  __typename?: 'SettingConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SettingConnection>;
};

export type SettingConnectionId = {
  __typename?: 'SettingConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SettingConnection>;
};

export type SettingConnectionName = {
  __typename?: 'SettingConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SettingConnection>;
};

export type SettingConnectionUpdatedAt = {
  __typename?: 'SettingConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SettingConnection>;
};

export type SettingGroupBy = {
  __typename?: 'SettingGroupBy';
  id?: Maybe<Array<Maybe<SettingConnectionId>>>;
  _id?: Maybe<Array<Maybe<SettingConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<SettingConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<SettingConnectionUpdatedAt>>>;
  name?: Maybe<Array<Maybe<SettingConnectionName>>>;
};

export type SettingInput = {
  name?: Maybe<Scalars['String']>;
};

export type StyledTable = {
  __typename?: 'StyledTable';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  Title?: Maybe<Scalars['String']>;
  contents?: Maybe<Scalars['String']>;
  Footnotes?: Maybe<Scalars['String']>;
  number: Scalars['String'];
};

export type StyledTableAggregator = {
  __typename?: 'StyledTableAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type StyledTableConnection = {
  __typename?: 'StyledTableConnection';
  values?: Maybe<Array<Maybe<StyledTable>>>;
  groupBy?: Maybe<StyledTableGroupBy>;
  aggregate?: Maybe<StyledTableAggregator>;
};

export type StyledTableConnection_Id = {
  __typename?: 'StyledTableConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<StyledTableConnection>;
};

export type StyledTableConnectionContents = {
  __typename?: 'StyledTableConnectionContents';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<StyledTableConnection>;
};

export type StyledTableConnectionCreatedAt = {
  __typename?: 'StyledTableConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<StyledTableConnection>;
};

export type StyledTableConnectionFootnotes = {
  __typename?: 'StyledTableConnectionFootnotes';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<StyledTableConnection>;
};

export type StyledTableConnectionId = {
  __typename?: 'StyledTableConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<StyledTableConnection>;
};

export type StyledTableConnectionNumber = {
  __typename?: 'StyledTableConnectionNumber';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<StyledTableConnection>;
};

export type StyledTableConnectionTitle = {
  __typename?: 'StyledTableConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<StyledTableConnection>;
};

export type StyledTableConnectionUpdatedAt = {
  __typename?: 'StyledTableConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<StyledTableConnection>;
};

export type StyledTableGroupBy = {
  __typename?: 'StyledTableGroupBy';
  id?: Maybe<Array<Maybe<StyledTableConnectionId>>>;
  _id?: Maybe<Array<Maybe<StyledTableConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<StyledTableConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<StyledTableConnectionUpdatedAt>>>;
  Title?: Maybe<Array<Maybe<StyledTableConnectionTitle>>>;
  contents?: Maybe<Array<Maybe<StyledTableConnectionContents>>>;
  Footnotes?: Maybe<Array<Maybe<StyledTableConnectionFootnotes>>>;
  number?: Maybe<Array<Maybe<StyledTableConnectionNumber>>>;
};

export type StyledTableInput = {
  Title?: Maybe<Scalars['String']>;
  contents?: Maybe<Scalars['String']>;
  Footnotes?: Maybe<Scalars['String']>;
  number: Scalars['String'];
};

export type Supplementary = {
  __typename?: 'Supplementary';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  resource?: Maybe<Array<Maybe<UploadFile>>>;
};


export type SupplementaryResourceArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type SupplementaryAggregator = {
  __typename?: 'SupplementaryAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SupplementaryConnection = {
  __typename?: 'SupplementaryConnection';
  values?: Maybe<Array<Maybe<Supplementary>>>;
  groupBy?: Maybe<SupplementaryGroupBy>;
  aggregate?: Maybe<SupplementaryAggregator>;
};

export type SupplementaryConnection_Id = {
  __typename?: 'SupplementaryConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SupplementaryConnection>;
};

export type SupplementaryConnectionCreatedAt = {
  __typename?: 'SupplementaryConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SupplementaryConnection>;
};

export type SupplementaryConnectionId = {
  __typename?: 'SupplementaryConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SupplementaryConnection>;
};

export type SupplementaryConnectionName = {
  __typename?: 'SupplementaryConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SupplementaryConnection>;
};

export type SupplementaryConnectionUpdatedAt = {
  __typename?: 'SupplementaryConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SupplementaryConnection>;
};

export type SupplementaryGroupBy = {
  __typename?: 'SupplementaryGroupBy';
  id?: Maybe<Array<Maybe<SupplementaryConnectionId>>>;
  _id?: Maybe<Array<Maybe<SupplementaryConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<SupplementaryConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<SupplementaryConnectionUpdatedAt>>>;
  name?: Maybe<Array<Maybe<SupplementaryConnectionName>>>;
};

export type SupplementaryInput = {
  name?: Maybe<Scalars['String']>;
  resource?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type Table = {
  __typename?: 'Table';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
  headers?: Maybe<Scalars['JSON']>;
  groups?: Maybe<Scalars['JSON']>;
  footnotes?: Maybe<Scalars['String']>;
  filterMap?: Maybe<Scalars['JSON']>;
  subgroups?: Maybe<Scalars['JSON']>;
  number: Scalars['String'];
};

export type TableAggregator = {
  __typename?: 'TableAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TableConnection = {
  __typename?: 'TableConnection';
  values?: Maybe<Array<Maybe<Table>>>;
  groupBy?: Maybe<TableGroupBy>;
  aggregate?: Maybe<TableAggregator>;
};

export type TableConnection_Id = {
  __typename?: 'TableConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TableConnection>;
};

export type TableConnectionCreatedAt = {
  __typename?: 'TableConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TableConnection>;
};

export type TableConnectionData = {
  __typename?: 'TableConnectionData';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<TableConnection>;
};

export type TableConnectionFilterMap = {
  __typename?: 'TableConnectionFilterMap';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<TableConnection>;
};

export type TableConnectionFootnotes = {
  __typename?: 'TableConnectionFootnotes';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TableConnection>;
};

export type TableConnectionGroups = {
  __typename?: 'TableConnectionGroups';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<TableConnection>;
};

export type TableConnectionHeaders = {
  __typename?: 'TableConnectionHeaders';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<TableConnection>;
};

export type TableConnectionId = {
  __typename?: 'TableConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TableConnection>;
};

export type TableConnectionName = {
  __typename?: 'TableConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TableConnection>;
};

export type TableConnectionNumber = {
  __typename?: 'TableConnectionNumber';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TableConnection>;
};

export type TableConnectionSubgroups = {
  __typename?: 'TableConnectionSubgroups';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<TableConnection>;
};

export type TableConnectionUpdatedAt = {
  __typename?: 'TableConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TableConnection>;
};

export type TableGroupBy = {
  __typename?: 'TableGroupBy';
  id?: Maybe<Array<Maybe<TableConnectionId>>>;
  _id?: Maybe<Array<Maybe<TableConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<TableConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<TableConnectionUpdatedAt>>>;
  name?: Maybe<Array<Maybe<TableConnectionName>>>;
  data?: Maybe<Array<Maybe<TableConnectionData>>>;
  headers?: Maybe<Array<Maybe<TableConnectionHeaders>>>;
  groups?: Maybe<Array<Maybe<TableConnectionGroups>>>;
  footnotes?: Maybe<Array<Maybe<TableConnectionFootnotes>>>;
  filterMap?: Maybe<Array<Maybe<TableConnectionFilterMap>>>;
  subgroups?: Maybe<Array<Maybe<TableConnectionSubgroups>>>;
  number?: Maybe<Array<Maybe<TableConnectionNumber>>>;
};

export type TableInput = {
  name?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
  headers?: Maybe<Scalars['JSON']>;
  groups?: Maybe<Scalars['JSON']>;
  footnotes?: Maybe<Scalars['String']>;
  filterMap?: Maybe<Scalars['JSON']>;
  subgroups?: Maybe<Scalars['JSON']>;
  number: Scalars['String'];
};


export type UpdateAbbreviationInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditAbbreviationInput>;
};

export type UpdateAbbreviationPayload = {
  __typename?: 'updateAbbreviationPayload';
  abbreviation?: Maybe<Abbreviation>;
};

export type UpdateChartInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditChartInput>;
};

export type UpdateChartPayload = {
  __typename?: 'updateChartPayload';
  chart?: Maybe<Chart>;
};

export type UpdateCountryInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCountryInput>;
};

export type UpdateCountryPayload = {
  __typename?: 'updateCountryPayload';
  country?: Maybe<Country>;
};

export type UpdateImageInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditImageInput>;
};

export type UpdateImagePayload = {
  __typename?: 'updateImagePayload';
  image?: Maybe<Image>;
};

export type UpdateJobInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditJobInput>;
};

export type UpdateJobPayload = {
  __typename?: 'updateJobPayload';
  job?: Maybe<Job>;
};

export type UpdateMasterInfoInput = {
  data?: Maybe<EditMasterInfoInput>;
};

export type UpdateMasterInfoPayload = {
  __typename?: 'updateMasterInfoPayload';
  masterInfo?: Maybe<MasterInfo>;
};

export type UpdateObjectiveInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditObjectiveInput>;
};

export type UpdateObjectivePayload = {
  __typename?: 'updateObjectivePayload';
  objective?: Maybe<Objective>;
};

export type UpdateParagraphInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditParagraphInput>;
};

export type UpdateParagraphPayload = {
  __typename?: 'updateParagraphPayload';
  paragraph?: Maybe<Paragraph>;
};

export type UpdateReferenceInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditReferenceInput>;
};

export type UpdateReferencePayload = {
  __typename?: 'updateReferencePayload';
  reference?: Maybe<Reference>;
};

export type UpdateReportInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditReportInput>;
};

export type UpdateReportPayload = {
  __typename?: 'updateReportPayload';
  report?: Maybe<Report>;
};

export type UpdateRoleInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditRoleInput>;
};

export type UpdateRolePayload = {
  __typename?: 'updateRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type UpdateSectionInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditSectionInput>;
};

export type UpdateSectionPayload = {
  __typename?: 'updateSectionPayload';
  section?: Maybe<Section>;
};

export type UpdateSettingInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditSettingInput>;
};

export type UpdateSettingPayload = {
  __typename?: 'updateSettingPayload';
  setting?: Maybe<Setting>;
};

export type UpdateStyledTableInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditStyledTableInput>;
};

export type UpdateStyledTablePayload = {
  __typename?: 'updateStyledTablePayload';
  styledTable?: Maybe<StyledTable>;
};

export type UpdateSupplementaryInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditSupplementaryInput>;
};

export type UpdateSupplementaryPayload = {
  __typename?: 'updateSupplementaryPayload';
  supplementary?: Maybe<Supplementary>;
};

export type UpdateTableInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditTableInput>;
};

export type UpdateTablePayload = {
  __typename?: 'updateTablePayload';
  table?: Maybe<Table>;
};

export type UpdateUserInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditUserInput>;
};

export type UpdateUserPayload = {
  __typename?: 'updateUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};


export type UploadFile = {
  __typename?: 'UploadFile';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Morph>>>;
};


export type UploadFileRelatedArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UploadFileAggregator = {
  __typename?: 'UploadFileAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<UploadFileAggregatorSum>;
  avg?: Maybe<UploadFileAggregatorAvg>;
  min?: Maybe<UploadFileAggregatorMin>;
  max?: Maybe<UploadFileAggregatorMax>;
};

export type UploadFileAggregatorAvg = {
  __typename?: 'UploadFileAggregatorAvg';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMax = {
  __typename?: 'UploadFileAggregatorMax';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMin = {
  __typename?: 'UploadFileAggregatorMin';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorSum = {
  __typename?: 'UploadFileAggregatorSum';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileConnection = {
  __typename?: 'UploadFileConnection';
  values?: Maybe<Array<Maybe<UploadFile>>>;
  groupBy?: Maybe<UploadFileGroupBy>;
  aggregate?: Maybe<UploadFileAggregator>;
};

export type UploadFileConnection_Id = {
  __typename?: 'UploadFileConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionAlternativeText = {
  __typename?: 'UploadFileConnectionAlternativeText';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCaption = {
  __typename?: 'UploadFileConnectionCaption';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCreatedAt = {
  __typename?: 'UploadFileConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionExt = {
  __typename?: 'UploadFileConnectionExt';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionFormats = {
  __typename?: 'UploadFileConnectionFormats';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHash = {
  __typename?: 'UploadFileConnectionHash';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHeight = {
  __typename?: 'UploadFileConnectionHeight';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionId = {
  __typename?: 'UploadFileConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionMime = {
  __typename?: 'UploadFileConnectionMime';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionName = {
  __typename?: 'UploadFileConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionPreviewUrl = {
  __typename?: 'UploadFileConnectionPreviewUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider = {
  __typename?: 'UploadFileConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider_Metadata = {
  __typename?: 'UploadFileConnectionProvider_metadata';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionSize = {
  __typename?: 'UploadFileConnectionSize';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUpdatedAt = {
  __typename?: 'UploadFileConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUrl = {
  __typename?: 'UploadFileConnectionUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionWidth = {
  __typename?: 'UploadFileConnectionWidth';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileGroupBy = {
  __typename?: 'UploadFileGroupBy';
  id?: Maybe<Array<Maybe<UploadFileConnectionId>>>;
  _id?: Maybe<Array<Maybe<UploadFileConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<UploadFileConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<UploadFileConnectionUpdatedAt>>>;
  name?: Maybe<Array<Maybe<UploadFileConnectionName>>>;
  alternativeText?: Maybe<Array<Maybe<UploadFileConnectionAlternativeText>>>;
  caption?: Maybe<Array<Maybe<UploadFileConnectionCaption>>>;
  width?: Maybe<Array<Maybe<UploadFileConnectionWidth>>>;
  height?: Maybe<Array<Maybe<UploadFileConnectionHeight>>>;
  formats?: Maybe<Array<Maybe<UploadFileConnectionFormats>>>;
  hash?: Maybe<Array<Maybe<UploadFileConnectionHash>>>;
  ext?: Maybe<Array<Maybe<UploadFileConnectionExt>>>;
  mime?: Maybe<Array<Maybe<UploadFileConnectionMime>>>;
  size?: Maybe<Array<Maybe<UploadFileConnectionSize>>>;
  url?: Maybe<Array<Maybe<UploadFileConnectionUrl>>>;
  previewUrl?: Maybe<Array<Maybe<UploadFileConnectionPreviewUrl>>>;
  provider?: Maybe<Array<Maybe<UploadFileConnectionProvider>>>;
  provider_metadata?: Maybe<Array<Maybe<UploadFileConnectionProvider_Metadata>>>;
};

export type UserInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  reports?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt: Scalars['String'];
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  id: Scalars['ID'];
  username: Scalars['String'];
  email: Scalars['String'];
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsMeRole>;
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: Scalars['String'];
  controller: Scalars['String'];
  action: Scalars['String'];
  enabled: Scalars['Boolean'];
  policy?: Maybe<Scalars['String']>;
  role?: Maybe<UsersPermissionsRole>;
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<UsersPermissionsPermission>>>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};


export type UsersPermissionsRolePermissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsRoleUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UsersPermissionsRoleAggregator = {
  __typename?: 'UsersPermissionsRoleAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UsersPermissionsRoleConnection = {
  __typename?: 'UsersPermissionsRoleConnection';
  values?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  groupBy?: Maybe<UsersPermissionsRoleGroupBy>;
  aggregate?: Maybe<UsersPermissionsRoleAggregator>;
};

export type UsersPermissionsRoleConnection_Id = {
  __typename?: 'UsersPermissionsRoleConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionCreatedAt = {
  __typename?: 'UsersPermissionsRoleConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionDescription = {
  __typename?: 'UsersPermissionsRoleConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionId = {
  __typename?: 'UsersPermissionsRoleConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionName = {
  __typename?: 'UsersPermissionsRoleConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionType = {
  __typename?: 'UsersPermissionsRoleConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionUpdatedAt = {
  __typename?: 'UsersPermissionsRoleConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleGroupBy = {
  __typename?: 'UsersPermissionsRoleGroupBy';
  id?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionId>>>;
  _id?: Maybe<Array<Maybe<UsersPermissionsRoleConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionUpdatedAt>>>;
  name?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionName>>>;
  description?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionDescription>>>;
  type?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionType>>>;
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsRole>;
  reports?: Maybe<Array<Maybe<Report>>>;
};


export type UsersPermissionsUserReportsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UsersPermissionsUserAggregator = {
  __typename?: 'UsersPermissionsUserAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UsersPermissionsUserConnection = {
  __typename?: 'UsersPermissionsUserConnection';
  values?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  groupBy?: Maybe<UsersPermissionsUserGroupBy>;
  aggregate?: Maybe<UsersPermissionsUserAggregator>;
};

export type UsersPermissionsUserConnection_Id = {
  __typename?: 'UsersPermissionsUserConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionBlocked = {
  __typename?: 'UsersPermissionsUserConnectionBlocked';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionConfirmed = {
  __typename?: 'UsersPermissionsUserConnectionConfirmed';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCreatedAt = {
  __typename?: 'UsersPermissionsUserConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionEmail = {
  __typename?: 'UsersPermissionsUserConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionId = {
  __typename?: 'UsersPermissionsUserConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionProvider = {
  __typename?: 'UsersPermissionsUserConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionRole = {
  __typename?: 'UsersPermissionsUserConnectionRole';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUpdatedAt = {
  __typename?: 'UsersPermissionsUserConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUsername = {
  __typename?: 'UsersPermissionsUserConnectionUsername';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserGroupBy = {
  __typename?: 'UsersPermissionsUserGroupBy';
  id?: Maybe<Array<Maybe<UsersPermissionsUserConnectionId>>>;
  _id?: Maybe<Array<Maybe<UsersPermissionsUserConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUpdatedAt>>>;
  username?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUsername>>>;
  email?: Maybe<Array<Maybe<UsersPermissionsUserConnectionEmail>>>;
  provider?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProvider>>>;
  confirmed?: Maybe<Array<Maybe<UsersPermissionsUserConnectionConfirmed>>>;
  blocked?: Maybe<Array<Maybe<UsersPermissionsUserConnectionBlocked>>>;
  role?: Maybe<Array<Maybe<UsersPermissionsUserConnectionRole>>>;
};

export type ReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportsQuery = (
  { __typename?: 'Query' }
  & { reports?: Maybe<Array<Maybe<(
    { __typename?: 'Report' }
    & Pick<Report, 'title' | 'id' | 'createdAt'>
    & { author?: Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & Pick<UsersPermissionsUser, 'id' | 'username'>
    )>, objectives?: Maybe<Array<Maybe<(
      { __typename?: 'Objective' }
      & Pick<Objective, 'id'>
    )>>> }
  )>>> }
);

export type ReportQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReportQuery = (
  { __typename?: 'Query' }
  & { report?: Maybe<(
    { __typename?: 'Report' }
    & Pick<Report, 'title'>
    & { pdf?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'url'>
    )>, docx?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'url'>
    )>, objectives?: Maybe<Array<Maybe<(
      { __typename?: 'Objective' }
      & Pick<Objective, 'id' | 'name'>
    )>>>, countries?: Maybe<Array<Maybe<(
      { __typename?: 'Country' }
      & Pick<Country, 'id' | 'name' | 'partOf'>
    )>>>, settings?: Maybe<Array<Maybe<(
      { __typename?: 'Setting' }
      & Pick<Setting, 'id' | 'name'>
    )>>> }
  )> }
);

export type SectionsQueryVariables = Exact<{
  objectives?: Maybe<Array<Maybe<Scalars['ID']>>>;
  settings?: Maybe<Array<Maybe<Scalars['ID']>>>;
  countries?: Maybe<Array<Maybe<Scalars['ID']>>>;
}>;


export type SectionsQuery = (
  { __typename?: 'Query' }
  & { sections?: Maybe<Array<Maybe<(
    { __typename?: 'Section' }
    & { content?: Maybe<Array<Maybe<(
      { __typename: 'ComponentReportContentChart' }
      & ChartFieldsFragment
    ) | (
      { __typename: 'ComponentReportContentImage' }
      & ImageFieldsFragment
    ) | (
      { __typename: 'ComponentReportContentParagraph' }
      & ParagraphFieldsFragment
    ) | (
      { __typename: 'ComponentReportContentTable' }
      & TableFieldsFragment
    ) | (
      { __typename: 'ComponentReportContentStyledTable' }
      & StyledTableFieldsFragment
    )>>> }
    & SectionFieldsFragment
  )>>> }
);

export type TocQueryVariables = Exact<{ [key: string]: never; }>;


export type TocQuery = (
  { __typename?: 'Query' }
  & { sections?: Maybe<Array<Maybe<(
    { __typename?: 'Section' }
    & { sections?: Maybe<Array<Maybe<(
      { __typename?: 'Section' }
      & SectionFieldsFragment
    )>>> }
    & SectionFieldsFragment
  )>>> }
);

export type SectionFieldsFragment = (
  { __typename?: 'Section' }
  & Pick<Section, 'id' | 'order1' | 'order2' | 'order3' | 'order4' | 'title'>
  & { references?: Maybe<Array<Maybe<(
    { __typename?: 'Reference' }
    & Pick<Reference, 'id' | 'number' | 'description' | 'link'>
    & { fullText?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'name' | 'url'>
    )> }
  )>>> }
);

export type ParagraphFieldsFragment = (
  { __typename?: 'ComponentReportContentParagraph' }
  & { paragraph?: Maybe<(
    { __typename?: 'Paragraph' }
    & Pick<Paragraph, 'id' | 'title' | 'body'>
  )> }
);

export type ChartFieldsFragment = (
  { __typename?: 'ComponentReportContentChart' }
  & { chart?: Maybe<(
    { __typename?: 'Chart' }
    & Pick<Chart, 'title' | 'number'>
    & { table?: Maybe<(
      { __typename?: 'Table' }
      & Pick<Table, 'name' | 'headers' | 'data' | 'filterMap' | 'footnotes'>
    )> }
  )> }
);

export type TableFieldsFragment = (
  { __typename?: 'ComponentReportContentTable' }
  & { table?: Maybe<(
    { __typename?: 'Table' }
    & Pick<Table, 'name' | 'headers' | 'data' | 'groups' | 'subgroups' | 'filterMap' | 'footnotes' | 'number'>
  )> }
);

export type StyledTableFieldsFragment = (
  { __typename?: 'ComponentReportContentStyledTable' }
  & { styled_table?: Maybe<(
    { __typename?: 'StyledTable' }
    & Pick<StyledTable, 'Title' | 'contents' | 'Footnotes' | 'number'>
  )> }
);

export type ReferenceFieldsFragment = (
  { __typename?: 'ComponentReportContentReference' }
  & { reference?: Maybe<(
    { __typename?: 'Reference' }
    & Pick<Reference, 'id' | 'number' | 'description' | 'link'>
    & { fullText?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'name' | 'url'>
    )> }
  )> }
);

export type ImageFieldsFragment = (
  { __typename?: 'ComponentReportContentImage' }
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'title'>
    & { image?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'url' | 'name'>
    )> }
  )> }
);

export type FiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type FiltersQuery = (
  { __typename?: 'Query' }
  & { objectives?: Maybe<Array<Maybe<(
    { __typename?: 'Objective' }
    & Pick<Objective, 'id' | 'name'>
  )>>>, countries?: Maybe<Array<Maybe<(
    { __typename?: 'Country' }
    & Pick<Country, 'id' | 'name' | 'partOf'>
  )>>>, settings?: Maybe<Array<Maybe<(
    { __typename?: 'Setting' }
    & Pick<Setting, 'id' | 'name'>
  )>>> }
);

export type CreateReportMutationVariables = Exact<{
  name: Scalars['String'];
  objectives?: Maybe<Array<Scalars['ID']>>;
  countries?: Maybe<Array<Scalars['ID']>>;
  settings?: Maybe<Array<Scalars['ID']>>;
}>;


export type CreateReportMutation = (
  { __typename?: 'Mutation' }
  & { createReport?: Maybe<(
    { __typename?: 'createReportPayload' }
    & { report?: Maybe<(
      { __typename?: 'Report' }
      & Pick<Report, 'id'>
    )> }
  )> }
);

export type UpdateReportMutationVariables = Exact<{
  id: Scalars['ID'];
  data: EditReportInput;
}>;


export type UpdateReportMutation = (
  { __typename?: 'Mutation' }
  & { updateReport?: Maybe<(
    { __typename?: 'updateReportPayload' }
    & { report?: Maybe<(
      { __typename?: 'Report' }
      & Pick<Report, 'id'>
    )> }
  )> }
);

export type DeleteReportMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteReportMutation = (
  { __typename?: 'Mutation' }
  & { deleteReport?: Maybe<(
    { __typename?: 'deleteReportPayload' }
    & { report?: Maybe<(
      { __typename?: 'Report' }
      & Pick<Report, 'id'>
    )> }
  )> }
);

export type AbbreviationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AbbreviationsQuery = (
  { __typename?: 'Query' }
  & { abbreviations?: Maybe<Array<Maybe<(
    { __typename?: 'Abbreviation' }
    & Pick<Abbreviation, 'acronym' | 'description'>
  )>>> }
);

export type SupplementariesQueryVariables = Exact<{ [key: string]: never; }>;


export type SupplementariesQuery = (
  { __typename?: 'Query' }
  & { supplementaries?: Maybe<Array<Maybe<(
    { __typename?: 'Supplementary' }
    & Pick<Supplementary, 'name'>
    & { resource?: Maybe<Array<Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'name' | 'url' | 'ext'>
    )>>> }
  )>>> }
);

export type MasterInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type MasterInfoQuery = (
  { __typename?: 'Query' }
  & { masterInfo?: Maybe<(
    { __typename?: 'MasterInfo' }
    & Pick<MasterInfo, 'id' | 'title' | 'version'>
  )> }
);

export const SectionFieldsFragmentDoc = gql`
    fragment SectionFields on Section {
  id
  order1
  order2
  order3
  order4
  title
  references {
    id
    number
    description
    fullText {
      id
      name
      url
    }
    link
  }
}
    `;
export const ParagraphFieldsFragmentDoc = gql`
    fragment ParagraphFields on ComponentReportContentParagraph {
  paragraph {
    id
    title
    body
  }
}
    `;
export const ChartFieldsFragmentDoc = gql`
    fragment ChartFields on ComponentReportContentChart {
  chart {
    title
    number
    table {
      name
      headers
      data
      filterMap
      footnotes
    }
  }
}
    `;
export const TableFieldsFragmentDoc = gql`
    fragment TableFields on ComponentReportContentTable {
  table {
    name
    headers
    data
    groups
    subgroups
    filterMap
    footnotes
    number
  }
}
    `;
export const StyledTableFieldsFragmentDoc = gql`
    fragment StyledTableFields on ComponentReportContentStyledTable {
  styled_table {
    Title
    contents
    Footnotes
    number
  }
}
    `;
export const ReferenceFieldsFragmentDoc = gql`
    fragment ReferenceFields on ComponentReportContentReference {
  reference {
    id
    number
    description
    fullText {
      id
      name
      url
    }
    link
  }
}
    `;
export const ImageFieldsFragmentDoc = gql`
    fragment ImageFields on ComponentReportContentImage {
  image {
    title
    image {
      url
      name
    }
  }
}
    `;
export const ReportsDocument = gql`
    query Reports {
  reports(sort: "updatedAt:desc") {
    title
    id
    createdAt
    author {
      id
      username
    }
    objectives {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReportsGQL extends Apollo.Query<ReportsQuery, ReportsQueryVariables> {
    document = ReportsDocument;
    
  }
export const ReportDocument = gql`
    query Report($id: ID!) {
  report(id: $id) {
    title
    pdf {
      url
    }
    docx {
      url
    }
    objectives {
      id
      name
    }
    countries {
      id
      name
      partOf
    }
    settings {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReportGQL extends Apollo.Query<ReportQuery, ReportQueryVariables> {
    document = ReportDocument;
    
  }
export const SectionsDocument = gql`
    query Sections($objectives: [ID] = [], $settings: [ID] = [], $countries: [ID] = []) {
  sections(where: {objectives_in: $objectives, settings_in: $settings, countries_in: $countries}, sort: "order1:asc,order2:asc,order3:asc,order4:asc") {
    ...SectionFields
    content {
      __typename
      ... on ComponentReportContentParagraph {
        ...ParagraphFields
      }
      ... on ComponentReportContentChart {
        ...ChartFields
      }
      ... on ComponentReportContentTable {
        ...TableFields
      }
      ... on ComponentReportContentStyledTable {
        ...StyledTableFields
      }
      ... on ComponentReportContentImage {
        ...ImageFields
      }
    }
  }
}
    ${SectionFieldsFragmentDoc}
${ParagraphFieldsFragmentDoc}
${ChartFieldsFragmentDoc}
${TableFieldsFragmentDoc}
${StyledTableFieldsFragmentDoc}
${ImageFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SectionsGQL extends Apollo.Query<SectionsQuery, SectionsQueryVariables> {
    document = SectionsDocument;
    
  }
export const TocDocument = gql`
    query TOC {
  sections(where: {order2_null: true}, sort: "order1:asc,order2:asc,order3:asc,order4:asc") {
    ...SectionFields
    sections {
      ...SectionFields
    }
  }
}
    ${SectionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TocGQL extends Apollo.Query<TocQuery, TocQueryVariables> {
    document = TocDocument;
    
  }
export const FiltersDocument = gql`
    query Filters {
  objectives {
    id
    name
  }
  countries {
    id
    name
    partOf
  }
  settings {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FiltersGQL extends Apollo.Query<FiltersQuery, FiltersQueryVariables> {
    document = FiltersDocument;
    
  }
export const CreateReportDocument = gql`
    mutation CreateReport($name: String!, $objectives: [ID!], $countries: [ID!], $settings: [ID!]) {
  createReport(input: {data: {title: $name, objectives: $objectives, countries: $countries, settings: $settings}}) {
    report {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateReportGQL extends Apollo.Mutation<CreateReportMutation, CreateReportMutationVariables> {
    document = CreateReportDocument;
    
  }
export const UpdateReportDocument = gql`
    mutation updateReport($id: ID!, $data: editReportInput!) {
  updateReport(input: {where: {id: $id}, data: $data}) {
    report {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateReportGQL extends Apollo.Mutation<UpdateReportMutation, UpdateReportMutationVariables> {
    document = UpdateReportDocument;
    
  }
export const DeleteReportDocument = gql`
    mutation DeleteReport($id: ID!) {
  deleteReport(input: {where: {id: $id}}) {
    report {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteReportGQL extends Apollo.Mutation<DeleteReportMutation, DeleteReportMutationVariables> {
    document = DeleteReportDocument;
    
  }
export const AbbreviationsDocument = gql`
    query Abbreviations {
  abbreviations(sort: "acronym:asc") {
    acronym
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AbbreviationsGQL extends Apollo.Query<AbbreviationsQuery, AbbreviationsQueryVariables> {
    document = AbbreviationsDocument;
    
  }
export const SupplementariesDocument = gql`
    query Supplementaries {
  supplementaries(sort: "name:asc") {
    name
    resource {
      id
      name
      url
      ext
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SupplementariesGQL extends Apollo.Query<SupplementariesQuery, SupplementariesQueryVariables> {
    document = SupplementariesDocument;
    
  }
export const MasterInfoDocument = gql`
    query MasterInfo {
  masterInfo {
    id
    title
    version
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MasterInfoGQL extends Apollo.Query<MasterInfoQuery, MasterInfoQueryVariables> {
    document = MasterInfoDocument;
    
  }